import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundary } from "~/components/ErrorBoundary";
import { NavigationProxyProvider } from "~/components/NavigationProxyProvider";
import { Toaster } from "~/components/Toaster";
import { VersionChecker } from "~/components/VersionChecker";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <NavigationProxyProvider>
        <Outlet />
        <VersionChecker />
      </NavigationProxyProvider>
      <Toaster />
    </ErrorBoundary>
  );
}
